import { gql } from "@apollo/client";

export const VOID_INVOICE = gql`
  mutation VoidInvoice($id: uuid!, $reason: String!, $voidedAt: timestamptz!) {
    void_invoice(id: $id, reason: $reason, voided_at: $voidedAt) {
      invoiceId: invoice_id
      voidedAt: voided_at
      reason
      updatedAt: updated_at
    }
  }
`;

export interface VoidInvoiceData {
  void_invoice: {
    invoiceId: string;
    voidedAt: string;
    reason: string;
    updatedAt: string;
  };
}

export interface VoidInvoiceVars {
  id: string;
  reason: string;
  voidedAt: Date;
}

export default VOID_INVOICE;
